import { activeContactTypeParser } from './utils/friendInboundUtils';
import { playerIdNameParser } from './utils/playerInboundUtils';
export const SHOW_FRIEND_REQUEST_PAYLOAD_DEFINITION = {
    definitionParts: [
        { name: 'activeContactType', parser: activeContactTypeParser },
        { name: 'playerIdName', parser: playerIdNameParser }
    ]
};
